import store from '@/store';
import {endOfNumberPath, validatePathIsEndOfNumber} from './validate';
import { layout } from 'platform';
import EmptyWrapper from '@/layouts/EmptyWrapper.vue'

export const RouterEn = [{
  path: '/en',
  meta: {
    type: 'website',
  },
  component: EmptyWrapper,
  children: [
    {
      path: '',
      name: 'homeEn',
      meta: {
        type: 'website',
        layout: "default-en-layout"
      },
      component: () => import(/* webpackChunkName: "homeEn" */ '../views/en/Home.vue'),
    },
    {
      path: 'hotel',
      redirect: 'hotel/1',
      props: {
        title1: 'SEARCH',
        title2: 'FIND THE HOTEL',
      },
      component: () => import(/* webpackChunkName: "search" */ '../components/layout/LayoutHasPagesTitle.vue'),
      children: [
        {
          path: ':p',
          name: 'hotel_all_pages_en',
          meta: {
            type: 'article',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/en/HotelSearch.vue'),
          beforeEnter: (to: any, from: any, next: any) => {
            validatePathIsEndOfNumber(to.path);
            next();
          },
        },
        {
          path: 'area/:area',
          redirect: 'area/:area/1',
          component: () => import(/* webpackChunkName: "search" */ '../views/en/HotelSearch.vue'),
          children: [
            {
              path: ':p',
              name: 'hotel_area_pages_en',
              meta: {
                type: 'article',
              },
              beforeEnter: (to: any, from: any, next: any) => {
                validatePathIsEndOfNumber(to.path);
                next();
              },
            },
          ],
        },
        {
          path: 'name/:name',
          name: 'hotel_name_en',
          meta: {
            type: 'article',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/HotelSearch.vue'),
        },
        {
          path: 'name/:name/map',
          name: 'hotel_map_en',
          meta: {
            type: 'article',
            title: 'MAP',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/en/Map.vue'),
        },
      ],
    },
    {
      path: 'resort',
      redirect: 'resort/1',
      props: {
        title1: 'SEARCH',
        title2: 'FIND THE HOTEL',
      },
      component: () => import(/* webpackChunkName: "search" */ '../components/layout/LayoutHasPagesTitle.vue'),
      children: [
        {
          path: ':p',
          name: 'resort_pages_en',
          meta: {
            type: 'article',
            brand: 'resort',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/en/ResortSearch.vue'),
          beforeEnter: (to: any, from: any, next: any) => {
            validatePathIsEndOfNumber(to.path);
            next();
          },
        },
        {
          path: 'area/:area',
          redirect: 'area/:area/1',
          component: () => import(/* webpackChunkName: "search" */ '../views/en/ResortSearch.vue'),
          children: [
            {
              path: ':p',
              name: 'resort_area_pages_en',
              meta: {
                type: 'article',
                brand: 'resort',
              },
              beforeEnter: (to: any, from: any, next: any) => {
                validatePathIsEndOfNumber(to.path);
                next();
              },
            },
          ],
        },
        {
          path: 'name/:name',
          name: 'resort_name_en',
          meta: {
            type: 'article',
            brand: 'resort',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/en/ResortSearch.vue'),
        },
      ],
    },
    {
      path: 'search/:keyword',
      redirect: 'search/:keyword/1',
      props: {
        title1: 'KEYWORD',
        title2: 'FIND THE HOTEL',
      },
      component: () => import(/* webpackChunkName: "search" */ '../components/layout/LayoutHasPagesTitle.vue'),
      children: [
        {
          path: ':p',
          name: 'search_p_en',
          meta: {
            type: 'article',
          },
          component: () => import(/* webpackChunkName: "search" */ '../views/en/SearchKeyword.vue'),
          beforeEnter: (to: any, from: any, next: any) => {
            validatePathIsEndOfNumber(to.path);
            next();
          },
        },
      ],
    },
    {
      path: 'pages/:slug',
      name: 'pagesEn',
      meta: {
        isPublic: true,
        type: 'article',
      },
      component: () => import(/* webpackChunkName: "pages" */ '../views/Pages.vue'),
    },
    {
      path: 'specialoffer',
      props: {
        title1: 'SPECIAL OFFER',
        title2: '',
      },
      component: () => import(/* webpackChunkName: "specialoffer" */ '../components/layout/LayoutHasPagesTitle.vue'),
      children: [
        {
          path: '',
          meta: {
            lang: 'en',
          },
          component: () => import(/* webpackChunkName: "campaign" */ '../views/en/specialoffer/Index.vue'),
          beforeEnter: (to: any, from: any, next: any) => {
            const q: any = to.query;
            store.dispatch('head/updateTitle', 'SPECIAL OFFER');
            if (typeof q.p !== 'undefined') {
              next();
            } else {
              const query = Object.assign(q, {p: 1});
              next({ path: '/en/specialoffer/', query });
            }
          },
        },
        {
          path: ':id',
          component: () => import(/* webpackChunkName: "specialoffer" */ '../views/en/specialoffer/Id.vue'),
          children: [
            {
              path: '',
              name: 'specialoffer-en',
              meta: {
                type: 'article',
                category: 'offer',
                lang: 'en',
              },
              component: () => import(/* webpackChunkName: "specialoffer" */ '../views/en/specialoffer/_id/Index.vue'),
            },
          ],
        },
      ],
    },
    {
      path: 'login',
      name: 'loginEn',
      meta: {
        isPublic: true,
        title: 'LOGIN',
        type: 'website',
        layout: 'login-layout'
      },
      component: () => import(/* webpackChunkName: "loginEn" */ '../views/en/Login.vue'),
      beforeEnter: (to: any, from: any, next: any) => {
        if (store.getters['auth/token']) {
          next({ path: '/en' });
        } else {
          next();
        }
      },
    },
    {
      // 全てにマッチします
      path: '*',
      meta: {
        layout: "login-layout",
        isPublic: true,
      },
      component: () =>
        import(/* webpackChunkName: "EnError404" */ "../views/en/Error404.vue"),
      beforeEnter: (to: any, from: any, next: any) => {
        next({ path: '/en' });
      },
    },
  ],
}];
